import React, { useState } from "react";
import Sidebar from "../DesignSystem/Sidebar";
import "../../css/Marketing/Marketing.css";
import "../../css/Marketing/FinancialPromotions/FinancialPromotionsSubmission.css";
import PrimaryButton from "../DesignSystem/Buttons/PrimaryButton";
import SecondaryButton from "../DesignSystem/Buttons/SecondaryButton";
import AddBlog from "./Blogs/AddBlog";
import AddMedia from "./Media/AddMedia";
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../DesignSystem/Breadcrumb/Breadcrumb";

const Marketing = () => {
  const [activeTab, setActiveTab] = useState("blogs");

  return (
    <div className="Main-Page">
      <Helmet>
        <title>Marketing</title>
        <meta
          name="description"
          content="Manage marketing content including blogs and media."
        />
      </Helmet>
      <Sidebar />
      <div className="Main-Container">
        <div className="Marketing-Page">
          <Breadcrumb
            items={[
              {
                label: "Marketing",
                to: "/Department/Marketing",
              },
              { label: "Blogs and Media" },
            ]}
          />
          <div className="row space-between center">

          <div className="FP_H3">
            {activeTab === "blogs" ? "Blogs" : "Media"}
          </div>
          <div className="tab-container">
            {activeTab === "blogs" ? (
              <PrimaryButton
                type="button"
                label="Add Blog"
                onClick={() => setActiveTab("blogs")}
              />
            ) : (
              <SecondaryButton
                label="Add Blog"
                onClick={() => setActiveTab("blogs")}
              />
            )}

            {activeTab === "media" ? (
              <PrimaryButton
                type="button"
                label="Add Media"
                onClick={() => setActiveTab("media")}
              />
            ) : (
              <SecondaryButton
                label="Add Media"
                onClick={() => setActiveTab("media")}
              />
            )}
          </div>
          </div>

          <div className="tab-content">
            {activeTab === "blogs" && <AddBlog />}

            {activeTab === "media" && <AddMedia />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketing;
